import "./RaikoUploaderHeaderItem.scss"
import {useEffect, useState} from "react";
import RaikoDrawer, {RaikoDrawerDirection} from "../../raikoDrawer/RaikoDrawer.tsx";
import RaikoUploaderDrawer from "../raikoUploaderDrawer/RaikoUploaderDrawer";
import * as React from "react";
import {useRaikoUploadManager} from "../RaikoUploadManagerContext";
import icUploadCloud from "../img/ic-upload.svg"
import {RaikoCustomTooltip} from "@moeindal/base-raiko-panel-components";


export default function RaikoUploaderHeaderItem({}) {
    const [openUploadDrawerStatus, setOpenUploadDrawerStatus] = useState(false)
    const handleOpenUploadDrawer = () => setOpenUploadDrawerStatus(true)
    const handleCloseUploadDrawer = () => setOpenUploadDrawerStatus(false)


    const {uploads, pendingCount} = useRaikoUploadManager()

    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        if (uploads.length > 0) {
            setAnimate(true);
            const timeout = setTimeout(() => setAnimate(false), 1000);
            return () => clearTimeout(timeout);
        }
    }, [uploads.length]);


    return (<>

        <RaikoDrawer
            openDrawer={openUploadDrawerStatus}
            anchor={RaikoDrawerDirection.LEFT}
            onClose={handleCloseUploadDrawer}
        >
            <RaikoUploaderDrawer handleCloseUploadDrawer={handleCloseUploadDrawer}/>
        </RaikoDrawer>
        <RaikoCustomTooltip title={"فضای ابری"}>
            <div className={`baseRaikoUploaderHeaderItemContainer ${animate ? 'shake' : ''}`}>
                <img src={icUploadCloud} alt={"icUploadCloud"} onClick={handleOpenUploadDrawer}/>
                {
                    pendingCount > 0 && <div className={`baseRaikoUploaderHeaderItemPendingCount `}/>
                }
            </div>
        </RaikoCustomTooltip>

    </>)
}